/*
 * @Author: your name
 * @Date: 2021-07-20 14:18:36
 * @LastEditTime: 2021-07-23 09:26:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edi
 * @FilePath: \admine:\LBB\front_end_nest_app_project\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/fonts/font.css'
// import 'lib-flexible/flexible'
import { PasswordInput, NumberKeyboard, Button, Image as VanImage, Lazyload, Icon, Tab, Tabs, Search, DropdownMenu, DropdownItem, Checkbox, CheckboxGroup, Swipe, SwipeItem, Popup, Cell, Form, GoodsAction, GoodsActionIcon, GoodsActionButton, Toast, Rate, Tag, Divider, TreeSelect, List, Field, NavBar } from 'vant'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});
import '@/assets/css/base.css'
Vue.use(Viewer)
  .use(Button)
  .use(VanImage)
  .use(Lazyload)
  .use(Icon)
  .use(Tab)
  .use(Tabs)
  .use(Search)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Swipe)
  .use(SwipeItem)
  .use(Popup)
  .use(Cell)
  .use(Form)
  .use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Toast)
  .use(Rate)
  .use(Tag)
  .use(Divider)
  .use(TreeSelect)
  .use(List)
  .use(Field)
  .use(PasswordInput)
  .use(NumberKeyboard)
  .use(NavBar);
Vue.config.productionTip = false;
Vue.prototype.uniJump = (type, data) => {
  uni.postMessage({
    data: {
      // title: meta[to.name],
      type: type,  // 1关闭  2提货列表
      data: data, // 其他的参数
    },
  });
}
document.body.addEventListener('touchstart', function () { });// 解决不能使用伪类元素点击效果
new Vue({
  render: h => h(App),
  router,
	store,
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js